
export default {
    name: 'QuotesRow',
    props: {
        /**
         * Quote Object
         */
        quote: {
            type: Object,
            required: true,
        },
        /**
         * Job Object
         */
        job: {
            type: Object,
            required: true,
        },
    },
    computed: {
        dates() {
            if (!this.quote.schedule_starts) {
                return this.quote.scheduled_at;
            }

            return `${this.quote.schedule_starts} - ${this.quote.scheduled_at}`;
        },
    },
};
